import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=47197daa&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=47197daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47197daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47197daa')) {
      api.createRecord('47197daa', component.options)
    } else {
      api.reload('47197daa', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=47197daa&scoped=true&", function () {
      api.rerender('47197daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NMV1k2jn78Dy/JS/comp/GuestBox.vue"
export default component.exports